var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWatchedIcon = function SvgWatchedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00BA00",
    d: "M9 18A9 9 0 1 0 9 0a9 9 0 0 0 0 18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.192 13.388 2.9 9.865a1.203 1.203 0 0 1 .057-1.696 1.203 1.203 0 0 1 1.696.057l2.54 2.718 4.018-3.755q.055-.05.113-.094l1.89-1.765a1.203 1.203 0 0 1 1.696.057c.45.482.425 1.246-.057 1.696L9.08 12.476l-.006-.006-1.996 1.865z",
    clipRule: "evenodd"
  })));
};
export default SvgWatchedIcon;